<div
    (click)="redirectToWhatsApp()"
    [class.dark-whatsapp-support]="themeService.isDark()"
    class="whatsapp-support"
>
    <i class="bx bxl-whatsapp"></i>
    <span class="whatsapp-support-text">Chat with us!</span>
</div>
